import BaseModel from '@core/model';

import IntegrationStatusEnum from '@constants/enums/integration/status';
import IntegrationTypeEnum from '@constants/enums/integration/type';

export class Integration extends BaseModel {
    static name = 'Integration';
    static entity = 'integrations';

    static fields() {
        return {
            id: this.attr(null),
            name: this.string(null).nullable(),
            type: this.enum(IntegrationTypeEnum).nullable(),
            status: this.enum(IntegrationStatusEnum).nullable()
        };
    }
}

export default Integration;
